var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"desktop-nav flex flex-col m-b-lg"},[_c('div',{staticClass:"desktop-nav__main-nav theme-bg--black-light"},[_c('div',{staticClass:"container max-height"},[_vm._t("main-nav")],2)]),_vm._v(" "),_c('div',{staticClass:"desktop-nav__sub-nav theme-bg--black"},[_c('div',{staticClass:"container max-height"},[_vm._t("sub-nav")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }